import axios from 'axios';
import config from './config';

const OFFERS_API = `${config.API_BASE_URL}/offers`;

// ✅ FIXED: Now accepts currency parameter
export const fetchOffers = async (branchId, currency = 'YER') => {
  try {
    // ✅ Build URL with both branchId and currency
    const params = [];
    if (branchId) {
      params.push(`branchId=${branchId}`);
    }
    if (currency) {
      params.push(`currency=${currency}`);
    }
    
    const url = params.length > 0 ? `${OFFERS_API}?${params.join('&')}` : OFFERS_API;
    
    console.log('🔗 Fetching offers from:', url);
    
    const response = await axios.get(url);
    
    console.log('📦 Offers API response:', response.data);
    
    return response.data;
  } catch (error) {
    console.warn("❌ Fetch offers failed:", error);
    
    // Fallback: fetch without branchId if the backend doesn't support filtering yet
    if (branchId) {
      const fallbackUrl = currency ? `${OFFERS_API}?currency=${currency}` : OFFERS_API;
      console.log('🔄 Retrying without branchId:', fallbackUrl);
      const response = await axios.get(fallbackUrl);
      return response.data;
    }
    throw error;
  }
};
